import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import bgConfetti from 'Assets/images/confettiBg.png';

export const SuccessContainer = styled(FlexContainer)`
  background-image: url(${bgConfetti});
  background-color: ${({ theme: { colors } }) => colors.white};
  background-repeat: no-repeat;
  background-size: cover;
`;

export const BackgroundImage = styled.div<{ plan: string }>`
  position: relative;
  width: 100%;
  border-radius: ${({ theme: { reference } }) =>
    ` 0 0 ${reference.dimension_80} ${reference.dimension_80}`};
  overflow: hidden;
  ::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    background-color: ${({ theme: { system }, plan }) =>
      system.plans[`fds_sys_color_plan_${plan}_quaternary`]};
    border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_O};
    width: 100%;
    height: 160px;
  }
  img {
    display: block;
    position: relative;
    max-height: 247px;
    margin: 0 auto;
  }
`;

export const TextContainer = styled(FlexContainer)`
 img {
  width: 20px
  height: 20px;
  margin-left: 10px;
 }
`;
